
import axios, { AxiosError } from 'axios';
import { jwtAuthProvider } from '../auth-provider/ra-auth-jwt';


const axiosWithAuthInterceptor = axios.create();

axiosWithAuthInterceptor.interceptors.request.use((config: any) => {
    const token: any = localStorage.getItem('credentials');

    if (token) {
        config.headers.Authorization = `${token}`;
    }

    return config;
});

axiosWithAuthInterceptor.interceptors.response.use(
    (response: any) => {
        if (response.data && response.data.err && (response.data.err.code === 401 || response.data.err.code === 403)) {
            window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/login`;
            jwtAuthProvider.logout(true);
        } else {
            return response;
        }
    },
    (error: AxiosError) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            const token: any = localStorage.getItem('credentials');

            if (!token) {
                window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/login`
                jwtAuthProvider.logout(true);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosWithAuthInterceptor;